/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_DeletingInputs */

const id_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menghapus...`)
};

const ms_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memadam...`)
};

const da_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sletter...`)
};

const de_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen...`)
};

const en_us2_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting...`)
};

const es_es2_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminando...`)
};

const es_mx2_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminando...`)
};

const fil_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inaalis...`)
};

const fr_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppression…`)
};

const it_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminazione in corso...`)
};

const hu_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Törlés...`)
};

const nl_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezig met verwijderen...`)
};

const no_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sletter...`)
};

const pl_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuwanie...`)
};

const pt_br2_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting...`)
};

const pt_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A eliminar...`)
};

const ro_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se șterge...`)
};

const fi_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poistetaan...`)
};

const sv_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tar bort...`)
};

const vi_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang xóa...`)
};

const tr_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siliniyor...`)
};

const cs_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mazání...`)
};

const bg_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изтриване...`)
};

const ru_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удаление...`)
};

const uk_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видалення...`)
};

const ar_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ الحذف...`)
};

const hi_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हटाया जा रहा है...`)
};

const th_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังลบ...`)
};

const ja_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除中...`)
};

const zh_cn2_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting...`)
};

const zh_hant1_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting...`)
};

const ko_forms_review_deleting = /** @type {(inputs: Forms_Review_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting...`)
};

/**
* | output |
* | --- |
* | "Deleting..." |
*
* @param {Forms_Review_DeletingInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_deleting = /** @type {((inputs?: Forms_Review_DeletingInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_DeletingInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_deleting(inputs)
	if (locale === "ms") return ms_forms_review_deleting(inputs)
	if (locale === "da") return da_forms_review_deleting(inputs)
	if (locale === "de") return de_forms_review_deleting(inputs)
	if (locale === "en-US") return en_us2_forms_review_deleting(inputs)
	if (locale === "es-ES") return es_es2_forms_review_deleting(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_deleting(inputs)
	if (locale === "fil") return fil_forms_review_deleting(inputs)
	if (locale === "fr") return fr_forms_review_deleting(inputs)
	if (locale === "it") return it_forms_review_deleting(inputs)
	if (locale === "hu") return hu_forms_review_deleting(inputs)
	if (locale === "nl") return nl_forms_review_deleting(inputs)
	if (locale === "no") return no_forms_review_deleting(inputs)
	if (locale === "pl") return pl_forms_review_deleting(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_deleting(inputs)
	if (locale === "pt") return pt_forms_review_deleting(inputs)
	if (locale === "ro") return ro_forms_review_deleting(inputs)
	if (locale === "fi") return fi_forms_review_deleting(inputs)
	if (locale === "sv") return sv_forms_review_deleting(inputs)
	if (locale === "vi") return vi_forms_review_deleting(inputs)
	if (locale === "tr") return tr_forms_review_deleting(inputs)
	if (locale === "cs") return cs_forms_review_deleting(inputs)
	if (locale === "bg") return bg_forms_review_deleting(inputs)
	if (locale === "ru") return ru_forms_review_deleting(inputs)
	if (locale === "uk") return uk_forms_review_deleting(inputs)
	if (locale === "ar") return ar_forms_review_deleting(inputs)
	if (locale === "hi") return hi_forms_review_deleting(inputs)
	if (locale === "th") return th_forms_review_deleting(inputs)
	if (locale === "ja") return ja_forms_review_deleting(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_deleting(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_deleting(inputs)
	return ko_forms_review_deleting(inputs)
});
export { forms_review_deleting as "forms.review.deleting" }